import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import Small from 'UIComponents/elements/Small';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import UIFlex from 'UIComponents/layout/UIFlex';
import { clearSelection, getIsQuerySelected, getSelectedRowIds } from '../redux/selectionSlice';

const BulkActionsContainer = ({
  BulkActionsComponent,
  totalRowCount
}) => {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const dispatch = useTableDispatch();
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "p-left-2",
    "data-test-id": "bulk-actions-container",
    children: [/*#__PURE__*/_jsx(Small, {
      className: "p-right-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.bulkActions.selectionCount",
        options: {
          count
        }
      })
    }), /*#__PURE__*/_jsx(BulkActionsComponent, {
      selection: selectedRowIds,
      querySelected: isQuerySelected,
      clearSelection: clearAllSelections
    })]
  });
};

export default BulkActionsContainer;